<template>
	<div>
		<Modal 
		:loading="loading" 
		:title="current != 'new' ? 'EDITAR CLIENTE' : 'NOVO CLIENTE'"
		@close="close"
		@save="save">
            <div class="row">
				<div class="col-xs">
					<small><b>Informações gerais</b></small>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-12">
					<FormSelect v-model="status" label="Status" :options="options.status" :required="true" tooltip="Selecione o status do cliente" ref="status" />
				</div>
				<div class="col-xs-12" :class="client_atak ? 'col-lg-6' : 'col-lg-12'">
					<FormInputMasked v-model="document" label="CPF/CNPJ" type="tel" :required="true" :mask="['###.###.###-##', '##.###.###/####-##']" :disabled="current != 'new' ? true : false" tooltip="Informe o documento de identificação do cliente" ref="document" />
				</div>
                <div v-if="client_atak" class="col-xs-12 col-lg-6">
					<FormInput v-model="code" label="Código do cliente" type="tel" :required="false" tooltip="Informe o código do cliente ('chave de fato' do registro do cliente no sistema integrado)" ref="code" />
				</div>
            </div>
            <div class="row">
				<div class="col-xs-12 col-lg-12">
					<FormInput v-model="name" label="Nome" type="text" :required="true" tooltip="Informe o nome do cliente" ref="name" />
				</div>
			</div>
            <div class="row">
				<div class="col-xs">
					<small><b>Informações de endereço</b></small>
				</div>
			</div>
			<form-group-address
				:current_id="id"
				:current_postal_code="postal_code"
				:current_street="street"
				:current_number="number"
				:current_complement="complement"
				:current_neighborhood="neighborhood"
				:current_city="city"
				:current_uf="uf"
				:current_country="country"
				:current_coordinates="coordinates"
				ref="formGroup"
			>
			</form-group-address>
			<div class="row">
				<div class="col-xs">
					<small><b>Informações de contato</b></small>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-4">
                    <FormInputMasked v-model="phone" label="Telefone" type="tel" :required="false" :mask="['(##) ####-####', '+## (##) #####-####']" tooltip="Informe o número de telefone para contato" ref="phone" />
				</div>
				<div class="col-xs-12 col-lg-4">
                    <FormInputMasked v-model="contact_mobile" label="Whatsapp" type="tel" :required="false" :mask="['(##) ####-####', '+## (##) #####-####']" tooltip="Informe o número do Whatsapp para contato" ref="contact_mobile" />
				</div>
				<div class="col-xs-12 col-lg-4">
					<FormInput v-model="contact_email" label="E-mail" type="email" :required="false" tooltip="Informe o e-mail para contato" ref="contact_email" />
				</div>
			</div>
            <div class="row">
				<div class="col-xs">
					<small><b>Informações de roteirização</b></small>
				</div>
			</div>
            <div class="row">
                <div class="col-xs-12 col-lg-6">
                    <FormInputMasked type="tel" label="Tempo médio de descarregamento" v-model="average_discharge_time" :mask="['# min','## min','### min','#### min','##### min']" tooltip="Informe o tempo médio que leva para descarregar entregas neste cliente (seja por questão de espaço, localidade, horário, etc)" ref="average_discharge_time" />
                </div>
            </div>
		</Modal>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormInput from "@/components/FormInput";
import FormInputMasked from "@/components/FormInputMasked";
import FormGroupAddress from '@/components/FormGroupAddress.vue';
import FormSelect from "@/components/FormSelect";

export default {
	name: "CustomerForm",

	props: {
		current: {
			type: [Object, String],
			required: true,
		},
	},

	components: {
		Modal,
		FormInput,
		FormInputMasked,
		FormGroupAddress,
		FormSelect,
	},

	data: function() {
		if (this.current != "new") {
			return {
				loading: false,
                
                id: this.current.id,
				status: this.current.status,
                document: this.current.document,
                code: this.current.code ? this.current.code : "",
                name: this.current.name,
                postal_code: this.current.postal_code,
                street: this.current.street.toUpperCase(),
                number: this.current.number ? this.current.number : "",
                complement: this.current.complement ? this.current.complement : "",
                neighborhood: this.current.neighborhood.toUpperCase(),
                city: this.current.city.toUpperCase(),
                uf: this.current.uf.toUpperCase(),
                country: this.current.country.toUpperCase(),
                coordinates: {
                    lat: this.current.coordinates.split(",")[0],
                    lng: this.current.coordinates.split(",")[1],
                },
                average_discharge_time: this.current.average_discharge_time ? this.current.average_discharge_time : "",
                phone: this.current.phone ? this.current.phone : "",
                contact_mobile: this.current.contact_mobile ? this.current.contact_mobile : "",
                contact_email: this.current.contact_email ? this.current.contact_email : "",

				options: {
					status: {
						1: "ATIVO",
						0: "INATIVO",
					}
				},

                client_atak: this.$api.user.company_client_atak,
			};
		}

		return {
			loading: false,
            
            id: "",
			status: "",
			document: "",
            code: "",
            name: "",
            postal_code: "",
            street: "",
            number: "",
            complement: "",
            neighborhood: "",
            city: "",
            uf: "",
            country: "BRASIL",
            coordinates: null,
            average_discharge_time: "",
            phone: "",
            contact_mobile: "",
            contact_email: "",

			options: {
					status: {
						1: "ATIVO",
						0: "INATIVO",
					}
				},

            client_atak: this.$api.user.company_client_atak,
		};
	},

	methods: {
        // Retorna menssagem de erro no campo determinado
        message: function(input) {
            return "'" + input + "' deve ser preenchido.";
        },

		// Verifica e valida inicialmente os campos
		validation: function() {
			let data = {
                id: "",
				status: "",
                document: "",
                code: "",
                name: "",
                postal_code: "",
                street: "",
                number: "",
                complement: "",
                neighborhood: "",
                city: "",
                uf: "",
                country: "BRASIL",
                coordinates: null,
                average_discharge_time: "",
                phone: "",
                contact_mobile: "",
                contact_email: "",
            };
			let error = false;
            
            data.id = this.id;

			if (this.status == "") {
				this.$refs.status.validate();
				this.$notification.error(this.message("STATUS"));
				error = true;
			} else {
				data.status = this.status;
			}
			
			if (this.document == "") {
				this.$refs.document.validate();
				this.$notification.error(this.message("CPF/CNPJ"));
				error = true;
			} else {
				data.document = this.document;
			}
            
            data.code = this.code;

            if (this.name == "") {
				this.$refs.name.validate();
				this.$notification.error(this.message("NOME"));
				error = true;
			} else {
				data.name = this.name;
			}

			let dataAddress = this.$refs.formGroup.validation();
			if (dataAddress) {
				data.postal_code = dataAddress.postal_code;
				data.street = dataAddress.street;
				data.number = dataAddress.number;
				data.complement = dataAddress.complement;
				data.neighborhood = dataAddress.neighborhood;
				data.city = dataAddress.city;
				data.uf = dataAddress.uf;
                data.country = dataAddress.country;
				data.coordinates = dataAddress.coordinates;
			} else {
				error = true;
			}

            data.phone = this.phone;
            data.contact_mobile = this.contact_mobile;
            data.contact_email = this.contact_email;
            
            data.average_discharge_time = this.average_discharge_time;
			
			// Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return data;
            }
		},

		// Envia para API e salva as informações no BD e XML
        save: async function() {
			if (this.id) {
				let confirm = await this.$alert.confirm("Deseja mesmo EDITAR esse cliente?");
				if (!confirm) return;
			}
			
			let data = this.validation();
			
			if (data == null) {
				return;
			}

			let form = {};
			form.data = data;
			
			this.loading = true;
			let result = null;
			try {
				result = await Api.post("customer/save", form);
			} catch (ex) {
				console.log(ex);
				this.$notification.error("Não foi possível processar as informações.");
				this.loading = false;
				return;
			}
			this.loading = false;
            
            if (result) {
				if (result.error) {
					this.$notification.error(result.data);
					return;
				} else {
					this.$notification.success("Cliente cadastrado com sucesso.");
					this.close();
					this.$parent.load();
					return;
				}
			} else {
				this.$notification.error("Não foi possível processar as informações.");
				return;
			}
		},

		// Fecha o modal
		close: function() {
			this.$parent.show_modal_form = false;
			this.$parent.current_form = null;
		},
	}
}
</script>

<style scoped>
.add-new-product {
	margin-top: 10px;
	border: none;
	background: #000;
	color: #d9d9d9;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
}

.remove-product {
	float: right;
	background-color: red;
	color: #fff;
	font-weight: 700;
	font-size: 12px;
	border: none;
	padding: 5px 15px;
}

.order-list-products {
	margin-bottom: 15px;
	border: 1px solid black;
}

.order-list-products-item {
	padding: 10px;
	border-top: 1px solid black;
	border-bottom: 1px solid black;
}

</style>